import React from 'react';
import { Box } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * PopupFooterSlot component.
 *
 * @author Mikhail Siutsou
 * @function PopupFooter
 * @category components
 * @param {PopupFooterProps} content props.
 * @return {JSX.Element} PopupFooterSlot component.
 */
var PopupFooter = function PopupFooter(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx(Box, {
    children: children
  });
};

PopupFooter.displayName = 'PopupFooter';
export { PopupFooter };